import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalTitle } from "@vertesia/ui/core";
import { SelectDocument } from "./SelectDocument";
export function SelectDocumentModal({ isOpen, onClose }) {
    return (_jsxs(Modal, { onClose: () => onClose(), isOpen: !!isOpen, className: 'min-w-[60vw]', children: [_jsx(ModalTitle, { children: "Select Content" }), _jsx(ModalBody, { className: 'pt-0 overflow-y-auto max-h-[80vh] min-h-[80vh]', children: isOpen && _jsx(SelectDocument, { onChange: onClose }) })] }));
}
//# sourceMappingURL=SelectDocumentModal.js.map